import NavLink from 'components/NavLink/NavLink';
import withColorQuery, { INavBarText, WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';

type Props = IWithCountryProps & WithColorQueryProps & WithLanguageProps;

export const FooterNav: React.SFC<Props> = props => {
  let text: INavBarText | { [key: string]: string } = {};
  if (!props.loading && props.data && props.data.fetch.Country.Navbar) {
    text = { ...props.data.fetch.Country.Navbar };
    Object.keys(text).forEach(key => (text[key] = props.getText(text[key])));
  }

  const routes = [
    {
      text: text.Home || 'Home',
      to: `/`
    },
    {
      text: text.About || 'About',
      to: `/about`
    },

    {
      text: text.Rules || 'Rules',
      to: `/rules`
    },
    {
      text: text.Events || 'Events',
      to: `/events`
    },
    // {
    //   text: text.Scores || 'Scores',
    //   to: `//scores`
    // },
    {
      text: text.WorldFinals || 'World Finals',
      to: `/world-finals`
    },
    {
      text: text.Contact || 'Contact',
      to: `/contact`
    }
  ];

  return (
    <Container>
      <ul>
        {routes.map((route, i) => {
          return (
            <li key={i}>
              <Link exact={true} to={route.to}>
                {route.text}
              </Link>
            </li>
          );
        })}
      </ul>
    </Container>
  );
};

const Link = styled(NavLink)`
  margin: 7px 0;
  @media (max-width: 1200px) {
    margin: 0;
  }
`;

const Container = styled.div`
  margin: 20px 0px 0px 50px;

  li {
    display: block;
    /* line-height: 0.5; */
    @media (max-width: 900px) {
      line-height: 1.5;
    }
  }
  @media (max-width: 1200px) {
    display: block;
    justify-content: space-around;
    flex: 1;
  }
`;

export default withLanguageState(withCountry(withColorQuery(FooterNav)));



// WEBPACK FOOTER //
// ./src/components/FooterNav/FooterNav.tsx